// import AllCorrectiveActionHub from '../../views/AssignedCorrectiveActionss';
import { useApiClients } from '../../client/api/useApiClient';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import {
  CorrectiveActionsPriorityEnum,
  CorrectiveActionsStatusEnum,
  GetAllDepartmentResponse,
  GetCorrectiveActionAssignedByMeResponse,
  Department,
  CorrectiveActionControllerGetAllCorrectiveActionAsssignedByMeAttentionNeededEnum,
} from '@EHSNavigator/backend';
import Loader from '../../components/Loader';
import AssignedCorrectiveActions from '../../views/AssignedCorrectiveActionss';

export default function AssignedCorrectiveActionsPage() {
  const { CorrectiveActionApi, DepartmentApi } = useApiClients();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') ?? '';
  const currentPage = searchParams.get('page') ?? 1;
  const status = searchParams.get('status') ?? null;
  const attentionNeeded = searchParams.get('attentionNeeded') ?? null;
  const priority = searchParams.get('priority') ?? null;
  const department = searchParams.get('department') ?? '';
  const limit = Number(searchParams.get('limit')) || 10;

  const query: any = {
    page: Number(currentPage),
  };
  if (searchQuery) query.search = searchQuery;
  if (status) query.status = status;
  if (priority) query.priority = priority;
  if (department) query.department = department;
  if (attentionNeeded) query.attentionNeeded = attentionNeeded;
  if (limit) query.limit = Number(limit);
  const {
    data: correctiveActions,
    isLoading,
    isRefetching,
  } = useQuery<GetCorrectiveActionAssignedByMeResponse, Error, any>({
    queryKey: [
      'all-corrective-action-assigned-by-me',
      Number(currentPage),
      status,
      priority,
      searchQuery,
      department,
      attentionNeeded,
      Number(limit),
    ],
    queryFn: async () => {
      const response =
        await CorrectiveActionApi.correctiveActionControllerGetAllCorrectiveActionAsssignedByMe(
          {
            search: searchQuery,
            page: Number(currentPage) || 1,
            limit: Number(limit),
            status: status as CorrectiveActionsStatusEnum,
            priority: priority as CorrectiveActionsPriorityEnum,
            departmentId: department,
            attentionNeeded:
              attentionNeeded as CorrectiveActionControllerGetAllCorrectiveActionAsssignedByMeAttentionNeededEnum,
          },
        );

      return response?.data;
    },
  });

  const { data: allDepartments, isLoading: isDepartmentLoading } =
    useQuery<GetAllDepartmentResponse>({
      queryKey: ['departments'],
      queryFn: async () => {
        const response =
          await DepartmentApi.departmentControllerFindAllDepartment({
            disablePagination: true,
          });
        return response?.data;
      },
    });

  const hasFilters =
    !!searchQuery ||
    !!status ||
    !!priority ||
    !!department ||
    !!attentionNeeded;

  const noDataMessage = hasFilters
    ? 'No items match your filters or search. Try using different keywords maybe.'
    : 'No corrective action assigned';

  const departments =
    allDepartments?.departments?.map((node: Department) => ({
      label: node?.name,
      value: node?.id,
    })) || [];

  if (isDepartmentLoading) {
    return <Loader />;
  }

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <AssignedCorrectiveActions
        data={correctiveActions}
        isLoading={isLoading || isRefetching}
        noDataMessage={noDataMessage}
        departments={departments}
        params={{
          search: searchQuery,
          page: Number(currentPage),
          departmentId: department,
          status: status as CorrectiveActionsStatusEnum,
          priority: priority as CorrectiveActionsPriorityEnum,
          attentionNeeded:
            attentionNeeded as CorrectiveActionControllerGetAllCorrectiveActionAsssignedByMeAttentionNeededEnum,
          limit: Number(limit),
        }}
      />
    </div>
  );
}
